import config from '../config';

// do to the backend sending non-supported instruements in an undesirably ordered fashion
// we have to do the filtering and sorting on the front end
var filterSortSupportedInstruments = function filterSortSupportedInstruments(itemsArray) {
  if (!config.global.instruments || config.global.instruments.length === 0) {
    return itemsArray;
  }
  var filteredSortedInstruments = [];
  config.global.instruments.forEach(function (symbol) {
    var instrument = itemsArray.find(function (item) {
      return item.Symbol === symbol;
    });
    if (instrument) {
      filteredSortedInstruments.push(instrument);
    }
  });
  return filteredSortedInstruments;
};
export default filterSortSupportedInstruments;